'use client';

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import {
  FaHandshake, FaUsers, FaShieldAlt,
  FaLightbulb, FaStar, FaBuilding,
  FaIndustry, FaTools, FaPaintBrush, FaCog
} from 'react-icons/fa';
import { Helmet } from 'react-helmet';
import ServicesIntro from './ServiceIntro.jsx';
import Cta from '../components/NewCallToAction';
const BRAND_BLUE = "#3b82f6";
const DARK_SLATE = "#0f172a";

// Helper Component for the centered accent bar
const DecorativeBar = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    gap: '8px',
    marginBottom: '32px',
    width: '100%'
  }}>
    <div style={{ width: '40px', height: '4px', background: '#0ea5e9', borderRadius: '2px' }} />
    <div style={{ width: '12px', height: '4px', background: '#22c55e', opacity: 0.3, borderRadius: '2px' }} />
    <div style={{ width: '40px', height: '4px', background: '#0ea5e9', borderRadius: '2px' }} />
  </div>
);

const ActionCard = ({ icon, title, description, tag }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <motion.article
      whileHover={{ y: -10 }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        background: '#ffffff',
        border: `1px solid ${isHovered ? BRAND_BLUE + '40' : '#f1f5f9'}`,
        borderRadius: '24px',
        padding: 'clamp(20px, 4vw, 32px)', // Fluid padding
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
        position: 'relative',
        boxShadow: isHovered
          ? `0 25px 50px ${BRAND_BLUE}10, 0 8px 16px rgba(0,0,0,0.03)`
          : '0 4px 12px rgba(0, 0, 0, 0.02)',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
        <div style={{
          width: '48px', height: '48px',
          background: isHovered ? BRAND_BLUE : `${BRAND_BLUE}10`,
          borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: isHovered ? '#fff' : BRAND_BLUE, transition: 'all 0.3s ease'
        }}>
          {icon}
        </div>
        {tag && (
          <span style={{
            fontSize: '10px', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '1px',
            color: isHovered ? BRAND_BLUE : '#64748b', background: isHovered ? `${BRAND_BLUE}10` : '#f8fafc',
            padding: '6px 12px', borderRadius: '20px', transition: 'all 0.3s ease'
          }}>
            {tag}
          </span>
        )}
      </div>

      <h3 style={{ fontSize: 'clamp(18px, 3vw, 20px)', fontWeight: 800, color: '#111827', marginBottom: '12px', letterSpacing: '-0.5px' }}>
        {title}
      </h3>

      <p style={{ fontSize: '14px', color: '#64748b', lineHeight: '1.6', marginBottom: '24px', flex: 1 }}>
        {description}
      </p>

      <motion.a
        href="/services"
        style={{

          padding: '12px 20px',
          background: isHovered ? BRAND_BLUE : 'transparent',
          color: isHovered ? 'white' : '#111827',
          border: `1px solid ${isHovered ? BRAND_BLUE : '#e2e8f0'}`,
          borderRadius: '12px',
          fontSize: '12px',
          fontWeight: 700,
          cursor: 'pointer',
          width: '100%',
          textTransform: 'uppercase'
        }}
      >
        Explore {title}
      </motion.a>
    </motion.article>
  );
};
const ActionCard2 = ({ icon, title, description, tag }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <motion.article
      whileHover={{ y: -10 }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        background: '#ffffff',
        border: `1px solid ${isHovered ? BRAND_BLUE + '40' : '#f1f5f9'}`,
        borderRadius: '24px',
        padding: 'clamp(20px, 4vw, 32px)', // Fluid padding
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
        position: 'relative',
        boxShadow: isHovered
          ? `0 25px 50px ${BRAND_BLUE}10, 0 8px 16px rgba(0,0,0,0.03)`
          : '0 4px 12px rgba(0, 0, 0, 0.02)',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
        <div style={{
          width: '48px', height: '48px',
          background: isHovered ? BRAND_BLUE : `${BRAND_BLUE}10`,
          borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: isHovered ? '#fff' : BRAND_BLUE, transition: 'all 0.3s ease'
        }}>
          {icon}
        </div>
        {tag && (
          <span style={{
            fontSize: '10px', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '1px',
            color: isHovered ? BRAND_BLUE : '#64748b', background: isHovered ? `${BRAND_BLUE}10` : '#f8fafc',
            padding: '6px 12px', borderRadius: '20px', transition: 'all 0.3s ease'
          }}>
            {tag}
          </span>
        )}
      </div>

      <h3 style={{ fontSize: 'clamp(18px, 3vw, 20px)', fontWeight: 800, color: '#111827', marginBottom: '12px', letterSpacing: '-0.5px' }}>
        {title}
      </h3>

      <p style={{ fontSize: '14px', color: '#64748b', lineHeight: '1.6', marginBottom: '24px', flex: 1 }}>
        {description}
      </p>


    </motion.article>
  );
};
const NewAboutUs = () => {
  const navigate = useNavigate();
  const [ref, inView] = useInView({ threshold: 0.1, triggerOnce: true });

  const stats = [
    { number: '10+', label: 'Years Experience' },
    { number: '100+', label: 'Projects' },
    { number: '400+', label: 'Skilled Workers' },
    { number: '50+', label: 'Clients' }
  ];

  const qatarProjects = [
    { icon: <FaBuilding />, title: 'Residential Projects', tag: 'Doha & Lusail', description: 'High-quality villas, compounds, and residential developments delivered across Doha and Lusail.' },
    { icon: <FaIndustry />, title: 'Commercial Projects', tag: 'Business Districts', description: 'Office buildings, retail spaces, and commercial facilities across major business hubs in Qatar.' },
    { icon: <FaTools />, title: 'Industrial Projects', tag: 'Industrial Zones', description: 'Factories, warehouses, and industrial facilities including epoxy flooring and protective works.' }
  ];

  const specializedServices = [
    { icon: <FaPaintBrush />, title: 'Painting Services', tag: 'Certified Team', description: 'Professional residential, commercial, and industrial painting services with durable finishes.' },
    { icon: <FaIndustry />, title: 'Waterproofing & Coatings', tag: 'Quality Assured', description: 'Waterproofing, epoxy floor coatings, and protective coating solutions across Qatar.' },
    { icon: <FaCog />, title: 'MEP Specialists', tag: 'Engineering Support', description: 'Experienced specialists for mechanical, electrical, and plumbing maintenance and support.' }
  ];

  return (
    <main style={{ background: '#f8fafc', width: '100%', overflowX: 'hidden' }}>
      <Helmet>
        <title>
          ISO Certified Construction Company Qatar | About Abraj Al Dhafna
        </title>

        <meta
          name="description"
          content="Established in 2014, Abraj Al Dhafna is Qatar's leading ISO certified construction manpower supply & civil subcontracting company. Specialized in MEP, fit-out, & industrial works."
        />

        <meta name="keywords" content="ISO certified construction company Qatar, construction manpower supply history, civil contractors Doha, MEP specialists Qatar, Abraj Al Dhafna profile, contracting WLL Qatar, established construction company Doha" />

        <link rel="canonical" href="https://abrajaldhafna.com/about" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "WebSite",
                "@id": "https://abrajaldhafna.com/#website",
                "url": "https://abrajaldhafna.com/",
                "name": "Abraj Al Dhafna Trading & Contracting WLL",
                "publisher": { "@id": "https://abrajaldhafna.com/#organization" }
              },
              {
                "@type": "Organization",
                "@id": "https://abrajaldhafna.com/#organization",
                "name": "Abraj Al Dhafna Trading & Contracting WLL",
                "url": "https://abrajaldhafna.com/",
                "logo": "https://abrajaldhafna.com/logo.jpeg",
                "foundingDate": "2014",
                "awards": "ISO 9001:2015 Certified",
                "email": "abrajaldhafna2014@gmail.com",
                "telephone": "+97444170859",
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": "Doha",
                  "addressCountry": "QA"
                },
                "sameAs": [
                  "https://www.linkedin.com/company/abraj-al-dhafna",
                  "https://www.facebook.com/abrajaldhafna",
                  "https://wa.me/97455994434",
                  "https://maps.google.com/?cid=YOUR_GOOGLE_BUSINESS_CID"
                ],
                "contactPoint": {
                  "@type": "ContactPoint",
                  "telephone": "+97444170859",
                  "contactType": "customer service",
                  "areaServed": "QA",
                  "availableLanguage": ["en", "ar"]
                }
              },
              {
                "@type": "AboutPage",
                "@id": "https://abrajaldhafna.com/about#aboutpage",
                "url": "https://abrajaldhafna.com/about",
                "name": "About Abraj Al Dhafna",
                "isPartOf": { "@id": "https://abrajaldhafna.com/#website" },
                "about": { "@id": "https://abrajaldhafna.com/#organization" },
                "description": "Company profile of Abraj Al Dhafna Trading & Contracting WLL, a leading ISO certified construction manpower supply and subcontracting company in Qatar."
              },
              {
                "@type": "Service",
                "name": "Construction Manpower Supply Qatar",
                "provider": { "@id": "https://abrajaldhafna.com/#organization" },
                "areaServed": "Qatar",
                "description": "Skilled and certified manpower supply for construction projects across Qatar."
              },
              {
                "@type": "Service",
                "name": "Construction Subcontracting Qatar",
                "provider": { "@id": "https://abrajaldhafna.com/#organization" },
                "areaServed": "Qatar",
                "description": "Civil, MEP, painting, waterproofing, and industrial subcontracting services in Qatar."
              },
              {
                "@type": "BreadcrumbList",
                "@id": "https://abrajaldhafna.com/about#breadcrumb",
                "itemListElement": [
                  {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Home",
                    "item": "https://abrajaldhafna.com/"
                  },
                  {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "About Us",
                    "item": "https://abrajaldhafna.com/about"
                  }
                ]
              }
            ]
          })}
        </script>
      </Helmet>
      <section aria-hidden="true" style={{ position: "absolute", left: "-9999px" }}>
        <h1>About Abraj Al Dhafna Construction Manpower Supply Company in Qatar</h1>
        <p>
          Abraj Al Dhafna Trading & Contracting WLL is an ISO certified construction manpower
          supply and subcontracting company in Qatar providing skilled labor, MEP specialists,
          painting, waterproofing, epoxy flooring, and industrial services across Doha, Lusail,
          West Bay, and all major project locations.
        </p>
      </section>


      {/* --- HERO SECTION --- */}
      <section style={heroStyles}>
        <div style={containerStyles}>
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} style={{ textAlign: 'center' }}>
            <span style={badgeStyles}>ESTABLISHED 2014</span>
            <h1 style={heroTitleStyles}>About <span style={{ color: BRAND_BLUE }}>Abraj Al Dhafna</span></h1>
            <p style={heroSubtitleStyles}>Qatar’s reliable partner for construction skilled manpower supply and civil subcontract works.</p>
          </motion.div>
        </div>
      </section>

      {/* --- COMPANY INTRO --- */}
      <section style={sectionPadding}>
        <div style={containerStyles}>
          <div style={{ textAlign: 'center', maxWidth: '900px', margin: '0 auto' }}>
            <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
              <h2 style={sectionTitleStyles}>Abraj Al Dhafna <span style={{ color: BRAND_BLUE }}>Trading & Contracting</span></h2>
              <DecorativeBar />
              {/* <p style={paragraphStyles}>
                ABRAJ AL DHAFNA TRADING AND CONTRACTING offers comprehensive services for Painting, Waterproofing, Concrete Repair, and Floor Epoxy Coating. As an ISO certified construction company, we lead in manpower supply across Qatar.
              </p>
              <p style={{ ...paragraphStyles, fontWeight: '700', color: BRAND_BLUE }}>
                Because success comes from working together.
              </p> */}
              <p style={paragraphStyles}>
                Established in 2014, ABRAJ AL DHAFNA TRADING AND CONTRACTING WLL is
                a leading provider of manpower supply and subcontracting. We support major projects 
                across construction, infrastructure, and oil & gas sectors. We offer end-to-end
                solutions for Painting, Waterproofing, Concrete Repair, and Floor Epoxy Coating with complete quality assurance.
              </p>
              <p style={paragraphStyles}>
                We are an ISO-certified construction company in Qatar. We specialize in providing
                skilled labor supply in Doha and professional manpower support throughout Qatar.
                We handle customized quotations, detailed planning, and precise job execution. 
                We make your construction experience smooth, efficient, and completely hassle-free.
              </p>
              <p style={paragraphStyles}>
                Our experienced workforce is respectful, disciplined, and highly committed. 
                We maintain the highest standards of workmanship. We offer reliable manpower in Qatar 
                with certified and experienced tradesmen capable of handling projects of any scale.
              </p>
              <p style={paragraphStyles}>
                Our teams are knowledgeable, friendly, and always ready to assist. 
                We ensure you are 100% satisfied at every stage. We collaborate 
                with Architects, Decorators, Homeowners, Contractors, and Developers across Qatar. 
                We execute complex projects on schedule and at highly competitive prices.
              </p>
              <p style={paragraphStyles}>
                ABRAJ AL DHAFNA has earned a strong reputation in Engineering and Construction. 
                We stand on competence, reliability, high quality standards, and a strong safety policy. 
                We provide 24/7 manpower supply in Qatar and expert construction helper supply in Doha for all major sectors.
              </p>
              <p style={{ ...paragraphStyles, fontWeight: '700', color: BRAND_BLUE }}>
                Because success comes from working together.
              </p>
            </motion.div>
            <ServicesIntro />

            {/* Stats Grid: Scales from 1 to 4 columns */}
            {/* <div style={statsGridStyles}>
              {stats.map((stat, i) => (
                <div key={i} style={statCardStyles}>
                  <div style={statNumberStyles}>{stat.number}</div>
                  <div style={statLabelStyles}>{stat.label}</div>
                </div>
              ))}
            </div> */}
          </div>
        </div>
      </section>
      {/* --- SERVICES & PROJECTS (Shared Layout) --- */}
      {[
        { title: "Specialized Construction", subtitle: "Services", data: specializedServices, description: 'Complete civil construction services including excavation, PCC & RCC works, foundations, columns, slabs, reinforcement steel fixing, blockwork, plastering, flooring base, waterproofing, drainage, paving, boundary walls, repair, maintenance, and minor demolition works.', bg: '#fff' },
        { title: "Serving Qatar's", subtitle: "Industry", data: qatarProjects, description: 'Specialized industrial services including waterproofing, epoxy flooring, protective coatings, and anti-corrosion systems for factories, plants, and industrial facilities across Qatar.', bg: '#f8fafc' }
      ].map((section, idx) => (
        <section key={idx} style={{ ...sectionPadding, background: section.bg }}>
          <div style={containerStyles}>
            <h2 style={{ ...sectionTitleStyles, textAlign: 'center', marginBottom: '10px' }}>
              {section.title} <span style={{ color: BRAND_BLUE }}>{section.subtitle}</span>
            </h2>
            <p style={{
              maxWidth: '800px',
              margin: '0 auto 40px', // Centers the text and adds space before the grid
              textAlign: 'center',
              color: '#64748b',      // Professional slate/grey color
              lineHeight: '1.6',
              fontSize: 'clamp(14px, 2vw, 16px)',
              padding: '0 15px'      // Prevents text touching edges on mobile
            }}>
              {section.description}
            </p>
            <DecorativeBar />

            {/* --- ADDED DESCRIPTION HERE --- */}


            <div style={cardGridStyles}>
              {section.data.map((item, i) => (
                <ActionCard key={i} {...item} />
              ))}
            </div>
          </div>
        </section>
      ))}

      {/* --- MISSION & VISION --- */}
      <section style={{ ...sectionPadding, background: '#262832ff', color: '#fff' }}>
        <div style={containerStyles}>
          <div ref={ref} style={missionGridStyles}>
            <motion.div style={missionCardStyles} initial={{ opacity: 0, y: 20 }} animate={inView ? { opacity: 1, y: 0 } : {}}>
              <FaStar style={{ color: BRAND_BLUE, fontSize: '2rem', marginBottom: '20px' }} />
              <h3 style={{ fontSize: '24px', marginBottom: '15px', }}>Our Mission</h3>
              <p style={{ opacity: 0.8, lineHeight: 1.7, fontSize: '14px', color: '#fff' }}>To become the regional market leader in Qatar's Construction industry by upholding ethics and best professional practices.</p>
            </motion.div>
            <motion.div style={missionCardStyles} initial={{ opacity: 0, y: 20 }} animate={inView ? { opacity: 1, y: 0 } : {}} transition={{ delay: 0.2 }}>
              <FaLightbulb style={{ color: BRAND_BLUE, fontSize: '2rem', marginBottom: '20px' }} />
              <h3 style={{ fontSize: '24px', marginBottom: '15px', color: '#fff' }}>Our Vision</h3>
              <p style={{ opacity: 0.8, lineHeight: 1.7, fontSize: '14px', color: '#fff' }}>To be the best professional partner of our clients, providing quality services that enable optimized project delivery.</p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* --- CORE VALUES --- */}
      <section style={sectionPadding}>
        <div style={containerStyles}>
          <div style={{ textAlign: 'center', marginBottom: '40px' }}>
            <h2 style={sectionTitleStyles}>Our Core <span style={{ color: BRAND_BLUE }}>Values</span></h2>
            <DecorativeBar />
          </div>
          <div style={cardGridStyles}>
            <ActionCard2 icon={<FaHandshake />} title="Commitment" tag="Excellence" description="Dedicated to delivering excellence and highest quality standards in every project." />
            <ActionCard2 icon={<FaUsers />} title="Respect" tag="Partnership" description="Valuing clients and employees with mutual respect and professional collaboration." />
            <ActionCard2 icon={<FaShieldAlt />} title="Integrity" tag="Ethics" description="Maintaining the highest ethical standards through transparency and honesty." />
          </div>
        </div>
      </section>
      <section style={{ ...sectionPadding, background: '#f8fafc' }}>
        <div style={containerStyles}>
          <div style={{
            background: '#0f172a', /* Dark Slate */
            borderRadius: '24px',
            padding: 'clamp(30px, 5vw, 60px)',
            position: 'relative',
            overflow: 'hidden',
            textAlign: 'center',
            color: 'white'
          }}>
            {/* Background Pattern */}
            <div style={{
              position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
              backgroundImage: 'radial-gradient(circle at 20% 150%, rgba(59,130,246,0.2) 0%, transparent 50%)',
              pointerEvents: 'none'
            }} />

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <h2 style={{
                fontSize: 'clamp(1.8rem, 5vw, 2.5rem)',
                fontWeight: 800,
                marginBottom: '20px',
                color: '#fff'
              }}>
                Build Your Career With Us
              </h2>
              <p style={{
                fontSize: 'clamp(16px, 2vw, 18px)',
                marginBottom: '30px',
                opacity: 0.8,
                maxWidth: '700px',
                margin: '0 auto 30px',
                lineHeight: 1.6,
                color: '#94a3b8' /* Slate 400 */
              }}>
                Are you a skilled professional looking for opportunities in Qatar's construction industry?
                Join our team of certified experts and work on prestigious projects.
              </p>

              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => navigate('/contact', { state: { activeTab: 'career' } })}
                style={{
                  background: '#3b82f6', /* Brand Blue */
                  color: '#fff',
                  padding: '16px 40px',
                  borderRadius: '12px',
                  fontWeight: 800,
                  fontSize: '16px',
                  border: 'none',
                  cursor: 'pointer',
                  boxShadow: '0 10px 25px rgba(59, 130, 246, 0.3)',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
              >
                Join Our Team <FaUsers />
              </motion.button>
              <p style={{ marginTop: '15px', fontSize: '14px', opacity: 0.6, color: '#94a3b8' }}>
                Select <strong>"Join Our Team"</strong> tab on the contact page.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      <Cta />
    </main>
  );
};

// --- RESPONSIVE STYLES OBJECTS ---
const containerStyles = {
  maxWidth: '1200px',
  margin: '0 auto',
  padding: '0 clamp(15px, 5vw, 40px)' // Responsive side gutter
};

const sectionPadding = {
  padding: 'clamp(60px, 10vw, 100px) 0' // Smaller padding on mobile
};

const heroStyles = {
  background: '#ebe6e6c4',
  padding: 'clamp(80px, 15vw, 140px) 0',
  textAlign: 'center'
};

const heroTitleStyles = {
  fontSize: 'clamp(2rem, 8vw, 4rem)',
  fontWeight: 800,
  marginBottom: '20px',
  lineHeight: 1.1
};

const heroSubtitleStyles = {
  fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
  opacity: 0.8,
  maxWidth: '600px',
  margin: '0 auto',
  lineHeight: 1.6
};

const badgeStyles = {
  background: 'rgba(59,130,246,0.1)',
  color: BRAND_BLUE,
  padding: '5px 15px',
  borderRadius: '20px',
  fontSize: '0.75rem',
  fontWeight: 700,
  marginBottom: '15px',
  display: 'inline-block',
  border: `1px solid ${BRAND_BLUE}40`
};

const sectionTitleStyles = {
  fontSize: 'clamp(1.75rem, 5vw, 2.5rem)',
  fontWeight: 800,
  color: DARK_SLATE,
  marginBottom: '10px'
};

const paragraphStyles = {
  fontSize: 'clamp(14px, 2vw, 16px)',
  lineHeight: '1.8',
  color: '#64748b',
  marginBottom: '20px'
};

// Grids
const statsGridStyles = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', // Responsive columns
  gap: 'clamp(12px, 3vw, 24px)',
  marginTop: '40px'
};

const cardGridStyles = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
  gap: '24px'
};

const missionGridStyles = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
  gap: '30px'
};

const statCardStyles = {
  background: '#fff',
  padding: '24px 15px',
  borderRadius: '20px',
  textAlign: 'center',
  border: '1px solid #e2e8f0'
};

const statNumberStyles = {
  fontSize: 'clamp(1.5rem, 4vw, 2.5rem)',
  fontWeight: 900,
  color: BRAND_BLUE
};

const statLabelStyles = {
  fontSize: '0.7rem',
  color: '#64748b',
  fontWeight: 700,
  textTransform: 'uppercase'
};

const missionCardStyles = {
  padding: 'clamp(24px, 5vw, 40px)',
  background: 'rgba(255,255,255,0.05)',
  borderRadius: '24px',
  border: '1px solid rgba(255,255,255,0.1)'
};

export default NewAboutUs;